import { BlockWithError } from "@/ui";
import { Slide } from "@mui/material";
import { FC, useEffect, useState } from "react";
import styles from "./CallingLineCalendar.module.scss";
import cn from "classnames";
import { useTranslate } from "@/hooks";
import { Calendar, NoticeSingleAction } from "@/components";
import { ICallingLineCalendar } from "./CallingLineCalendar.props";
import { useGetCallingListsConfigsQuery, useUpdateCallingListsConfigsMutation } from "@/store/RTKQuery/clsSlice";

const CallingLineCalendar: FC<ICallingLineCalendar> = ({ showCalendar, setShowCalendar }) => {
	const [showNotification, setShowNotification] = useState<boolean>(false); // показ уведомления
	const [snackbarMessage, setSnackbarMessage] = useState("");
	const [changeFlg, setChangeFlg] = useState<boolean>(false); // флаг, уведомляющий об изменении данных и возможности сохранить эти изменения
	const [initialHolidaysList, setInitialHolidaysList] = useState<string[]>([]);
	const {
		data: listsConfigs,
		isError,
		refetch,
	} = useGetCallingListsConfigsQuery(undefined, {
		refetchOnMountOrArgChange: false,
		refetchOnReconnect: false,
	});
	const [updateCallingListsConfigs] = useUpdateCallingListsConfigsMutation();

	useEffect(() => {
		if (listsConfigs && listsConfigs.error !== 1) {
			const data = listsConfigs.data;

			if (Array.isArray(data)) {
				const holidaysConfigs = data.find((el) => el.id === "holidays");
				if (holidaysConfigs && "dates" in holidaysConfigs.params) {
					setInitialHolidaysList(holidaysConfigs.params.dates);
				}
			}
		}
	}, [listsConfigs]);

	const translate = useTranslate();

	// закрыть вкладку календаря
	const closeHandler = (): void => {
		setShowCalendar(false);
	};

	//показать уведомление с сообщением
	const handleShowNotice = (message: string) => {
		setSnackbarMessage(message);
		setShowNotification(true);
	};

	// обработчик сохранения данных робота
	const handleSaveHolidaysChanges = (holidays: string[]): void => {
		setShowNotification(true);
		setSnackbarMessage(translate("notice_changesSaved"));
		updateCallingListsConfigs({ configId: "holidays", newConfigs: { id: "holidays", params: { dates: holidays } } })
			.unwrap()
			.then((res) => {
				if (res.error === 0) {
					setChangeFlg(false);
					handleShowNotice("notice_changesSaved");
				} else if (res.error === 1) {
					handleShowNotice(`${translate("notice_savingError")}: ${res.message}`);
				}
			})
			.catch((err) => {
				handleShowNotice(`${translate("notice_savingError")}: ${JSON.stringify(err)}`);
			});
	};

	return (
		<>
			<Slide direction="left" in={showCalendar} mountOnEnter unmountOnExit>
				<div className={cn(styles.modal)} onMouseDown={closeHandler}>
					<div className={cn(styles.configRobot)} onMouseDown={(e) => e.stopPropagation()}>
						{isError || listsConfigs?.error === 1 ? (
							<BlockWithError message={"title_error"} updateHandler={refetch} />
						) : (
							<Calendar
								isDisabled={false}
								changeFlg={changeFlg}
								setChangeFlg={setChangeFlg}
								saveChangesHandler={handleSaveHolidaysChanges}
								initialHolidayList={initialHolidaysList}
							/>
						)}

						<div className={cn(styles.tagClose)} onClick={closeHandler}>
							{translate("button_close")}
						</div>
					</div>
				</div>
			</Slide>
			<NoticeSingleAction
				severity={snackbarMessage.toLowerCase().includes("error") || snackbarMessage.toLowerCase().includes("ошибка") ? "error" : "info"}
				showNotification={showNotification}
				setShowNotification={setShowNotification}
				title={snackbarMessage}
			/>
		</>
	);
};

export default CallingLineCalendar;
